export default {"src":"/_next/static/media/0xae75a438b2e0cb8bb01ec1e1e376de11d44477cc.6d8b1f8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};